<ng-container *transloco="let t">
  <a
    *ngIf="product?.inStock"
    #cartBtn
    class="button popsy-button-primary buy-button highlight full-width"
    (click)="onAddToCart($event)">
    <span class="text">{{ t('action_add_to_cart') }}</span>
  </a>
  <!-- PRODUCT OUT OF STOCK -->
  <ng-container *ngIf="!product?.inStock">
    <button
      appElementLoaded
      [disabled]="true"
      class="button popsy-button-primary buy-button full-width"
      [attr.aria-label]="t('label_not_available')">
      <span class="text">{{ t('label_not_available') }}</span>
    </button>
  </ng-container>
</ng-container>
